import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Script = ({ src, strategy, ...props }) => <script src={src} {...props} />;
const Reviews = () => {
    return (_jsxs("section", { className: "w-full bg-white py-16 sm:py-20 lg:py-28", children: [_jsx("div", { className: "container mx-auto px-4 sm:px-6 lg:px-8", children: _jsx("div", { className: "elfsight-app-25f10fb7-2098-4d31-90a1-977e28d04b5b", "data-elfsight-app-lazy": "" }) }), _jsx(Script, { src: "https://elfsightcdn.com/platform.js", strategy: "afterInteractive" })] }));
};
export default Reviews;
